import { render, staticRenderFns } from "./ActivationBriefTaskDeliveryRouterView.vue?vue&type=template&id=dfaa73f4&"
import script from "./ActivationBriefTaskDeliveryRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefTaskDeliveryRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports